import { useContext } from 'react';
import { SourSearchContext } from '../formWrapper/SourSearchContext';
export function useSourSearchContext() {
    const context = useContext(SourSearchContext);
    if (!context) {
        throw new Error('useSourSearchContext must be used within a SourSearchProvider');
    }
    return context;
}
//# sourceMappingURL=useSourSearch.js.map